import { Routes, Route } from "react-router-dom";

import { Overview } from "./components/Overview.js";
import { SignUp } from "./components/SignUp.js";
import { BusinessDetails } from "./components/BusinessDetails.js";
import { OutletDetails } from "./components/OutletDetails.js";
import { ChooseIntegration } from "./components/ChooseIntegration.js";
import { SetupShopify } from "./components/SetupShopify.js";
import { SetupPetpooja } from "./components/SetupPetpooja.js";
import { ShopifyRedirect } from "./components/ShopifyRedirect.js";
import { Login } from "./components/Login.js";
import { Offers } from "./components/Offers.js";
import { Wallet } from "./components/Wallet.js";
import { Transactions } from "./components/Transactions.js";
import { Integrations } from "./components/Integrations.js";
import { LandingPage } from "./components/LandingPage.js";
import { AddOutlet } from "./components/AddOutlet.js";
import { CreateOffer } from "./components/CreateOffer.js";
import { TopUpWallet } from "./components/TopUpWallet.js";
import { InteractiveDemo } from "./components/InteractiveDemo.js";

import './index.css';

function App() {
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/interactive-demo" element={<InteractiveDemo />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/business-details" element={<BusinessDetails />} />
            <Route path="/outlet-details" element={<OutletDetails />} />
            <Route path="/choose-integration" element={<ChooseIntegration />} />
            <Route path="/setup/integrations/shopify" element={<SetupShopify />} />
            <Route path="/setup/integrations/shopify/redirect" element={<ShopifyRedirect />} />
            <Route path="/setup/integrations/petpooja" element={<SetupPetpooja />} />
            <Route path='/login' element={<Login />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/add-outlet" element={<AddOutlet />} />
            <Route path="/create-offer" element={<CreateOffer />} />
            <Route path="/top-up-wallet" element={<TopUpWallet />} />
        </Routes>
    );
}

export default App;